var arcane = (function () {
    function arcane() {
    }
    return arcane;
}());
export { arcane };
